import { render, staticRenderFns } from "./user-detail-dialog.vue?vue&type=template&id=27cbf512&scoped=true"
import script from "./user-detail-dialog.vue?vue&type=script&lang=js"
export * from "./user-detail-dialog.vue?vue&type=script&lang=js"
import style0 from "./user-detail-dialog.vue?vue&type=style&index=0&id=27cbf512&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27cbf512",
  null
  
)

export default component.exports